export const getImgUrl = (src, env) =>
  new URL(src, `https://${env.cloudinary.secureDistribution}/image/upload/t_v7/f_auto,q_auto:best,c_limit,w_%width%/v1/`).href
//
export function getTemplate(isMobile, sources, env) {
  return isMobile
    ? getImgUrl(sources.get("portrait").public_id, env).replace("%width%", 750).slice(0, -4)
    : getImgUrl(sources.get("landscape").public_id, env).replace("%width%", 1920).slice(0, -4)
}
